
export const labelLocalizationsMap = {
    documentsCount: [
        /* @kp-localization index.everbis.title */ 'index.everbis.title',
        /* @kp-localization index.everbis.234titles */ 'index.everbis.234titles',
        /* @kp-localization index.everbis.titles */ 'index.everbis.titles',
    ],
    newDocumentsCount: [
        /* @kp-localization index.everbis.title */ 'index.everbis.title',
        /* @kp-localization index.everbis.234titles */ 'index.everbis.234titles',
        /* @kp-localization index.everbis.titles */ 'index.everbis.titles',
    ],
    registeredReadersCount: [
        /* @kp-localization index.everbis.reader */ 'index.everbis.reader',
        /* @kp-localization index.everbis.234readers */ 'index.everbis.234readers',
        /* @kp-localization index.everbis.readers */ 'index.everbis.readers',
    ],
    activeLoansCount: [
        /* @kp-localization index.everbis.loan */ 'index.everbis.loan',
        /* @kp-localization index.everbis.234loans */ 'index.everbis.234loans',
        /* @kp-localization index.everbis.loans */ 'index.everbis.loans',
    ]
} as const;


export const noteLocalizationsMap = {
    documentsCount: [
        /* @kp-localization index.everbis.inCatalog */ 'index.everbis.inCatalog',
        /* @kp-localization index.everbis.inCatalog */ 'index.everbis.inCatalog',
        /* @kp-localization index.everbis.inCatalog */ 'index.everbis.inCatalog'
    ],
    newDocumentsCount: [
        /* @kp-localization index.everbis.1addedThisMonth */ 'index.everbis.1addedThisMonth',
        /* @kp-localization index.everbis.234addedThisMonth */ 'index.everbis.234addedThisMonth',
        /* @kp-localization index.everbis.moreAddedThisMonth */ 'index.everbis.moreAddedThisMonth'
    ],
    registeredReadersCount: [
        /* @kp-localization index.everbis.ofTheLibrary */ 'index.everbis.ofTheLibrary',
        /* @kp-localization index.everbis.ofTheLibrary */ 'index.everbis.ofTheLibrary',
        /* @kp-localization index.everbis.ofTheLibrary */ 'index.everbis.ofTheLibrary'
    ],
    activeLoansCount: [
        /* @kp-localization index.everbis.1234currentlyActive */ 'index.everbis.1234currentlyActive',
        /* @kp-localization index.everbis.1234currentlyActive */ 'index.everbis.1234currentlyActive',
        /* @kp-localization index.everbis.moreCurrentlyActive */ 'index.everbis.moreCurrentlyActive'
    ],
} as const;